export const NAMESPACE = 'TOP_READERS/';
export const SET_SOURCE = NAMESPACE + 'SET_SOURCE';
export const SET_TOP_PLACES_COUNT = NAMESPACE + 'SET_TOP_PLACES_COUNT';
export const SET_GROUPS_WITH_HIDDEN_MEMBERS = NAMESPACE + 'SET_GROUPS_WITH_HIDDEN_MEMBERS';
export const SET_NOT_PUBLICS = NAMESPACE + 'SET_NOT_PUBLICS';

export const SET_SUBPROGRESS = NAMESPACE + 'SET_SUBPROGRESS';
